import { useSelector } from "react-redux";

function ManualDownload(props: any) {

  const { urlDownloadDocument } = useSelector((state: any) => state.login);


  const downloadDocument = () => {
    var link: any = document.createElement("a");
    link.href = urlDownloadDocument;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }
  return (
    <>
      {urlDownloadDocument &&
        <button onClick={downloadDocument} className="manualDownload">
          <span className="material-symbols-outlined">
            menu_book
          </span>
        </button>
      }
    </>

  )
}

export default ManualDownload;